// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderInfo":"c-j_gw"};